
export class Country {
    public name: string;
    public code: string;
    public shortCode: string;
}


export class RawCountry {
    public nativeName: string;
    public alpha3Code: string;
    public alpha2Code: string;
}

export class ContactRequest {
    public firstName: string;
    public surname: string;
    public company: string;

    public sector: CompanySector;
    public job: string;
    public country: string;

    public contactMethod: ContactMethod;
    public mail: string;
    public phone: string;

    // public captchaChallenge: string;
    public note: string;

    public language: string;

}

export enum SendContactResponse
{
    Ok = 0,
    InvalidParameters = 1,
    InvalidCaptcha = 2,
    InternalError = 3
}

export enum ContactMethod {
    Mail = 0, Phone = 1
}

export enum CompanySector {
    CarRepairing = 0, Industry = 1, Handicraft = 2, Private = 3
}



// WEBPACK FOOTER //
// ./src/app/models.ts